export const CourseReportSortBy = Object.freeze(
 {
    Latest:0, // default
    Price:1,
    EstimatedTime:2
 })